import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

export interface MessageTemplate {
  id?: string;
  title: string;
  response_message: string;
  shared_with: string;
  userId?: string;
  createdByUserId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MessageTemplatesService {
  private get apiBaseUrl(): string {
    return environment.engageApiBaseUrl;
  }

  constructor(private readonly _dataService: DataService) {}

  getMessageTemplates(userId: string): Observable<MessageTemplate[]> {
    const url = `${this.apiBaseUrl}api/v1/message-templates?userId=${encodeURIComponent(userId)}`;
    return this._dataService.get(url).pipe(
      map((res: any) => {
        let items: any[] = Array.isArray(res) ? res : (res?.data ?? res?.templates ?? res?.items ?? []);
        return items.map(item => this.normalizeTemplate(item));
      })
    );
  }

  private normalizeTemplate(item: any): MessageTemplate {
    return {
      id: item.id,
      title: item.title ?? item.name ?? '',
      response_message: item.response_message ?? item.message ?? item.body ?? '',
      shared_with: item.shared_with ?? item.sharedWith ?? 'me',
      userId: item.userId ?? item.user_id,
      createdByUserId: item.createdByUserId ?? item.created_by_user_id ?? item.userId ?? item.user_id
    };
  }

  createMessageTemplate(payload: { title: string; response_message: string; shared_with: string }): Observable<MessageTemplate> {
    const url = `${this.apiBaseUrl}api/v1/message-templates`;
    return this._dataService.post(url, payload);
  }

  updateMessageTemplate(id: string, payload: { title: string; response_message: string; shared_with: string }): Observable<MessageTemplate> {
    const url = `${this.apiBaseUrl}api/v1/message-templates/${id}`;
    return this._dataService.patch(url, payload);
  }

  deleteMessageTemplate(id: string): Observable<void> {
    const url = `${this.apiBaseUrl}api/v1/message-templates/${id}`;
    return this._dataService.delete(url);
  }
}
